module.exports = {
	"it": {
		"ui.about.title.overview": "",
		"ui.about.subhead": "",
		"ui.about.overview": "",
		"ui.about.title.getting_started": "Come iniziare",
		"ui.about.getting_started": "",
		"ui.exports": "Esportazioni",
		"ui.exports.title": "Esportazioni",
		"ui.help": "Aiuto",
		"ui.login": "Accedi",
		"ui.about.license": "",
		"ui.about.license.odbl": "Sotto licenza ODbL 1.0",
		"ui.aoi_toolbar.tools": "",
		"ui.draw.box": "",
		"ui.draw.draw": "",
		"ui.draw.import": "",
		"ui.draw.current_view": "",
		"ui.authorized.thank_you": "",
		"configuration.description.label": "Descrizione",
		"ui.configuration.description.label": "Descrizione",
		"export.description.label": "Descrizione",
		"exports.description.label": "Descrizione",
		"configuration.description.placeholder": "",
		"configuration.feature_selection.label": "",
		"configuration.name.label": "Nome",
		"ui.configuration.name.label": "Nome",
		"export.name.label": "Nome",
		"exports.name.label": "Nome",
		"configuration.name.placeholder": "",
		"configuration.public.description": "",
		"ui.configuration.update": "",
		"ui.configuration.create": "",
		"ui.configuration.delete": "",
		"ui.configuration.title": "",
		"configuration.title": "",
		"ui.configurations": "",
		"ui.configuration.tables.label": "",
		"ui.configuration.owner.label": "",
		"exports.owner.label": "",
		"export.project.label": "Progetto",
		"exports.project.label": "Progetto",
		"export.area.label": "",
		"export.area": "",
		"export.created_at.label": "",
		"export.created_by.label": "",
		"export.published.label": "Pubblicata",
		"yes": "",
		"no": "",
		"export.export_formats.label": "",
		"export.osma.label": "",
		"ui.view_this_area": "",
		"ui.exports.status": "",
		"ui.exports.started": "",
		"ui.exports.finished": "",
		"ui.exports.duration": "",
		"ui.exports.features": "Funzionalità",
		"ui.exports.rerun_export": "",
		"ui.exports.clone_export": "",
		"ui.exports.feature_selection.title": "Selezione caratteristiche",
		"export.feature_selection.label": "Selezione caratteristiche",
		"ui.close": "Chiudi",
		"export.errors.the_geom.too_large": "",
		"export.buffer_aoi.description": "",
		"export.name.placeholder": "",
		"export.project.placeholder": "",
		"export.published.description": "",
		"export.tag_tree_search.placeholder": "",
		"nav.next": "",
		"export.feature_selection.load_from_josm_preset": "",
		"ui.clear": "",
		"configuration.load_yaml": "",
		"ui.exports.tag_tree": "",
		"ui.exports.stored_configuration": "",
		"ui.exports.create_export": "",
		"ui.exports.describe_export": "",
		"ui.exports.choose_formats": "",
		"ui.exports.select_features": "",
		"ui.exports.summary": "",
		"ui.overpass_last_updated": "",
		"ui.show_on_map": "",
		"exports.created.label": "",
		"ui.settings": "",
		"ui.never": "",
		"exports.schedule.6hrs": "",
		"exports.schedule.daily": "",
		"exports.schedule.weekly": "",
		"exports.schedule.monthly": "",
		"ui.unknown": "",
		"ui.untitled": "",
		"runs.last_run.label": "",
		"runs.next_run.label": "",
		"runs.schedule.label": "",
		"ui.private": "Privata",
		"ui.search.only_mine": "",
		"ui.search.placeholder": "",
		"ui.search": "",
		"ui.login_to_osm": "Accedi ad OpenStreetMap",
		"ui.hot.title": "Humanitarian OpenStreetMap Team",
		"ui.toggle_navigation": "",
		"ui.osm_export_tool.title": "",
		"ui.create": "Crea",
		"ui.hdx": "",
		"ui.about": "Informazioni",
		"ui.log_out": "Log out",
		"ui.log_in": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/i18n/locales/it.json
// module id = 1495
// module chunks = 1